import { useLocalStorageState, useUpdateEffect } from 'ahooks'
import { ColumnsType, ColumnType } from 'antd/lib/table'
import { useEffect, useState } from 'react'

interface useTableSortOptions<T> {
    key: string
    defaultValue: ColumnsType<T>
}

interface SortItemData {
    title: string
    key: string
    checked: boolean
}

export function useTableSort<T>(options: useTableSortOptions<T>) {
    const [sortColumn, setSortColumn] = useState<ColumnsType<T>>(options.defaultValue)
    const [sortData, setSortData] = useLocalStorageState<Array<SortItemData>>(
        `${options.key}_${localStorage.getItem('shopId')}`,
        options.defaultValue.map(v => ({
            title: v.title as string,
            key: v.key as string,
            checked: true,
        })),
    )

    useUpdateEffect(() => {
        if (sortData) {
            setSortColumn(() => {
                return sortData
                    .filter(s => s.checked)
                    .map(s => {
                        const val = options.defaultValue.find(sort => sort.key === s.key)

                        return val as ColumnType<T>
                    })
            })
        }
    }, [options.defaultValue])

    useEffect(() => {
        if (sortData) {
            setSortColumn(col => {
                return sortData
                    .filter(s => s.checked)
                    .map(s => options.defaultValue.find(sort => sort.key === s.key) as ColumnType<T>)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortData])

    return {
        sortColumn,
        setSortData,
        sortData: sortData || [],
    }
}
